import app from '../../app';
import { registerContext } from '../services/context-provider';
import { IFluxibleContext } from './../components/fluxible-context';

/**
 * Fluxible context wrapper,
 * please use it only on redux actions which are not fully migrated from fluxible.
 * Usage: import * as context  from 'state/fluxible-context'
 */

let context: IFluxibleContext;

export function initializeContext(): IFluxibleContext {
  const options = process.env.NODE_ENV !== 'production' ? { debug: true } : undefined;

  context = app.createContext(options);
  registerContext(context);
  return context;
}

export function executeAction(action: Function, payload: any = {}): void {
  return context.executeAction(action, payload);
}

export function getStore(storeName: string): any {
  return context.getStore(storeName);
}

export function dispatch(actionName: string, payload: any = {}): void {
  return context?.getActionContext()?.dispatch(actionName, payload);
}

// for debugging purposes
export function getFluxContext(): IFluxibleContext {
  return context;
}
